import { module as BaseModule } from 'modujs'
import { html } from '../utils/environment'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.menuButton = this.$('toggler')

    this.events = {
      click: {
        toggler: 'toggleMenu',
        close: 'closeMenu',
      },
    }
  }

  init() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.c-header')) return
      html.classList.remove('has-menu-open')
    })
  }

  toggleMenu() {
    html.classList.toggle('has-menu-open')

    this.menuButton.disabled = true

    setTimeout(() => {
      this.menuButton.disabled = false
    }, 1300)
  }

  closeMenu() {
    html.classList.remove('has-menu-open')
  }
}
